import { render, staticRenderFns } from "./CampusCreate.vue?vue&type=template&id=151c46a6&"
import script from "./CampusCreate.vue?vue&type=script&lang=js&"
export * from "./CampusCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports